import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img className="footer-logo" src="/Images/logo.png" alt="" width="88" height="88" />
            <h3 className="footer-brand">Oromo Gadaa-UK</h3>
            <p>Preserving our heritage, building our future together in the United Kingdom.</p>
          </div>
          <div className="footer-section">
            <h3>Explore</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Visit Us</h3>
            <p>127 Dean Road<br/>Bolton BL3 5AG<br/>Greater Manchester<br/>United Kingdom</p>
          </div>
          <div className="footer-section">
            <h3>Get in Touch</h3>
            <p><a href="mailto:oromogadaacommunity@gmail.com">oromogadaacommunity@gmail.com</a></p>
            <p><a href="tel:+447493193493">+44 7493 193493</a></p>
            <p>Mon · Wed · Fri, 10am – 2pm</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Oromo Gadaa-UK. All rights reserved.</p>
          <p>Safuu · Nagaa · Tokkummaa</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
